import { connect } from 'react-redux'
import AddMaintenanceCaseComponent from '../components/AddMaintenanceCaseComponent.jsx';
import {
  forwardToSetMaintainCaseReqParam, //addMaintenanceCaseActions
  forwardToFindAllMaintenanceOrderIds,
  findAllCustomerIds, //customerActions
  forwardToCreateMaintenanceCaseWithSerial,
  forwardToCreateMaintenanceCase,
  forwardToClearMaintenancePageState,
  forwardToSelectMcasesTab,
  forwardToFindProcessingMcases,
  forwardToAlertMCaseRequiredFields,
  forwardToAlertMCaseMessage,
  cleanAddCaseAlert
} from '../actions';

const mapStateToProps = (state) => ({
  //request
  mCaseRequest: state.getIn(['addMaintenanceCaseReducer', 'mCaseRequestModel']),

  //alert
  alert: state.getIn(['addMaintenanceCaseReducer', 'alert']),

  //view
  allCustomerIds: state.getIn(['orderReducer', 'allCustomerIds']),
  allOrderIds: state.getIn(['maintenanceOrderListReducer', 'allOrderIds']),

  // validation
  orderValidation: state.getIn(['orderReducer', 'orderValidation']),

})

const mapDispatchToProps = (dispatch) => ({
  setValue: (id, value) => {
    //set request parameter
    dispatch(forwardToSetMaintainCaseReqParam({
      param: id,
      value: value
    }))
  },

  clearState: (id, value) => {
    //set request parameter
    dispatch(forwardToClearMaintenancePageState());
  },

  findAllCustomerIds: () => {
    dispatch(findAllCustomerIds());
  },

  findAllOrderIds: () => {
    dispatch(forwardToFindAllMaintenanceOrderIds());
  },

  createMaintenanceCase: (orderId, prefix, initNo, org, unit, note, uploadFile, user) => {
    dispatch(forwardToCreateMaintenanceCase(
      orderId, prefix, initNo, org, unit, note, uploadFile, user));
  },

  createMaintenanceCaseWithSerial: (orderId, note, receivedDate, returnDate, uploadFile, user) => {
    dispatch(forwardToCreateMaintenanceCaseWithSerial(
      orderId, note, receivedDate, returnDate, uploadFile, user));
  },

  forwardToMCasesPage: () => {
    dispatch(forwardToSelectMcasesTab(0));
    dispatch(forwardToFindProcessingMcases());
  },

  alertRequired: () => {
    dispatch(forwardToAlertMCaseRequiredFields());
  },

  alertMessage: (message) => {
    dispatch(forwardToAlertMCaseMessage(message));
  },

  cleanAlert: () => {
    dispatch(cleanAddCaseAlert());
  }

})

const AddMaintenanceCaseContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddMaintenanceCaseComponent)

export default AddMaintenanceCaseContainer;


// WEBPACK FOOTER //
// ./src/containers/AddMaintenanceCaseContainer.jsx